import React from 'react';
import '../../styles/components/forms.css';

const PhraseInputs = ({ phrases, onChange }) => {
  // Calculate midpoint to split phrases into left and right columns
  const midPoint = Math.ceil(phrases.length / 2);
  const leftPhrases = phrases.slice(0, midPoint);
  const rightPhrases = phrases.slice(midPoint);

  return (
    <div className="phrase-inputs-container">
      <div className="phrase-column">
        {leftPhrases.map((phrase, index) => (
          <div key={`phrase-${index}`} className="form-group">
            <label className="input-label">{`Phrase ${index + 1}`}</label>
            <input
              type="text"
              className="form-control key-input"
              value={phrase}
              onChange={(e) => onChange(index, e.target.value)}
              placeholder={`Phrase ${index + 1}`}
            />
          </div>
        ))}
      </div>
      <div className="phrase-column">
        {rightPhrases.map((phrase, index) => (
          <div key={`phrase-${index + midPoint}`} className="form-group">
            <label className="input-label">{`Phrase ${index + midPoint + 1}`}</label>
            <input
              type="text"
              className="form-control key-input"
              value={phrase}
              onChange={(e) => onChange(index + midPoint, e.target.value)}
              placeholder={`Phrase ${index + midPoint + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhraseInputs;